import ChatIcon from '@mui/icons-material/Chat';
import { Theme, useMediaQuery } from '@mui/material';
import Grid from '@mui/material/Grid';
import { BooleanField, BooleanInput, Create, Datagrid, Edit, EditButton, FormTab, List, NumberField, NumberInput, SelectInput, Show, ShowActions, SimpleList, SimpleShowLayout, TabbedForm, TextField, TextInput, required, usePermissions, useResourceDefinition } from 'react-admin';
import { useParams } from 'react-router-dom';
import OptionReferenceField from 'utils/GeneratedRaReference/OptionReferenceField';
import OptionReferenceInput from 'utils/GeneratedRaReference/OptionReferenceInput';
import DateFnsField from 'utils/react-admin/DateFnsField';
import GridWrapper from 'utils/react-admin/GridWrapper';
import XlsHtmlExporter from 'utils/react-admin/exporters/XlsHtml';
import DateRangeFilterInput from 'utils/react-admin/filters/DateRangeFilterInput';
import { Permissions } from '../../ra-php-crud-api-auth';

export const CHOICES_OPINION_TITLE = [
  { id:'mr', name: 'mr', },
  { id:'ms', name: 'ms', },
];

export const CHOICES_OPINION_ABOUT = [
  { id:'general', name: 'general', },
  { id:'reservation', name: 'reservation', },
  { id:'chartered', name: 'chartered', },
  { id:'meeting', name: 'meeting', },
  { id:'opinion', name: 'opinion', },
];
// const RESOURCE_FIELDS = {}
const ResourceFilters = [
  <TextInput source="search" alwaysOn />,
  <BooleanInput source="is_public" fullWidth />,
  <NumberInput source="position" fullWidth />,
  <OptionReferenceInput source="question_category_id" fullWidth filter={{ option_type: 'question_category' }} />,
  <TextInput source="name" fullWidth />,
  <SelectInput source="title" fullWidth choices={CHOICES_OPINION_TITLE} />,
  <TextInput source="contact" fullWidth />,
  <TextInput source="email" fullWidth />,
  <SelectInput source="about" fullWidth choices={CHOICES_OPINION_ABOUT} />,
  <TextInput source="message" fullWidth />,
  <DateRangeFilterInput source="created" fullWidth />,
  <TextInput source="createdBy" fullWidth />,
  <DateRangeFilterInput source="updated" fullWidth />,
  <TextInput source="updatedBy" fullWidth />,
];

const validateIsPublic: any[] = [required()];
const validatePosition: any[] = [];
const validateQuestionCategoryId: any[] = [required()];
const validateName: any[] = [];
const validateTitle: any[] = [];
const validateContact: any[] = [];
const validateEmail: any[] = [];
const validateAbout: any[] = [];
const validateMessage: any[] = [];

export const ResourceList = () => {
  const isSmall = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

  return (
    <List filters={ResourceFilters} sort={{ field: 'created', order: 'DESC' }} exporter={XlsHtmlExporter}>
      {isSmall ? (
        <SimpleList linkType="edit"
          primaryText={(record: any) => `${record.title} (#${record.id})`}
          secondaryText={(record: any) => `${record.name}`}
        ></SimpleList>)
        : (
          <Datagrid>
            <TextField source="id" />
            <BooleanField source="is_public" fullWidth />
            <NumberField source="position" fullWidth />
            <OptionReferenceField source="question_category_id" fullWidth />
            <TextField source="name" fullWidth />
            <TextField source="title" fullWidth />
            <TextField source="about" fullWidth />
            <DateFnsField source="created" />
            <DateFnsField source="updated" />
            {/* <ShowButton /> */}
            <EditButton />
          </Datagrid>)
      }
    </List>
  )
};

export const ResourceShow = () => {
  const { isLoading, permissions } = usePermissions<Permissions>();
  const { hasEdit } = useResourceDefinition();

  if (isLoading || undefined === permissions) { return (<>Loading</>); }

  return (
    <Show actions={hasEdit ? <ShowActions /> : <></>}>
      <SimpleShowLayout>
        <TextField source="id" />
        <BooleanField source="is_public" fullWidth />
        <NumberField source="position" fullWidth />
        <OptionReferenceField source="question_category_id" fullWidth />
        <TextField source="name" fullWidth />
        <TextField source="title" fullWidth />
        <TextField source="contact" fullWidth />
        <TextField source="email" fullWidth />
        <TextField source="about" fullWidth />
        <TextField source="message" fullWidth />
        <DateFnsField source="created" />
        <DateFnsField source="updated" />
      </SimpleShowLayout>
    </Show>
  )
};

const transform = (data: any) => {
  console.log('transform', data);
  return data;
};

export const ResourceForm = ({ isEdit }: { isEdit?: boolean}) => {
  // const { getMany } = useDataProvider();
  const { ref, ref_id, ref_default_values } = useParams();
  // const redirect = ref_id ? `/${ref}/${ref_id}` : undefined;
  const defaultValueRefId = ref_id ? { [`${ref}_id`]: ref_id } : {};
  const refDefaultValues = ref_default_values ? JSON.parse(ref_default_values as string) : {};

  return (
    <TabbedForm
      defaultValues={{ ...defaultValueRefId, ...refDefaultValues }}
    >
      {/* redirect={redirect} */}
      <FormTab label="ra.page.general">
        <GridWrapper>
          <Grid item xs={6}></Grid>
        </GridWrapper>
        <BooleanInput source="is_public" fullWidth validate={validateIsPublic} />
        <NumberInput source="position" fullWidth validate={validatePosition} />
        <OptionReferenceInput source="question_category_id" fullWidth filter={{ option_type: 'question_category' }} validate={validateQuestionCategoryId} />
        <TextInput source="name" fullWidth validate={validateName} />
        <SelectInput source="title" fullWidth choices={CHOICES_OPINION_TITLE} validate={validateTitle} />
        <TextInput source="contact" fullWidth validate={validateContact} />
        <TextInput source="email" fullWidth validate={validateEmail} />
        <SelectInput source="about" fullWidth choices={CHOICES_OPINION_ABOUT} validate={validateAbout} />
        <TextInput multiline={true} minRows={3} maxRows={5} source="message" fullWidth validate={validateMessage} />
      </FormTab>

    </TabbedForm>
  )
}

export const ResourceCreate = () => {
  return (
    <Create mutationMode="pessimistic" transform={transform}>
      <ResourceForm />
    </Create>
  )
};

export const ResourceEdit = () => {
  return (
    <Edit mutationMode="pessimistic" transform={transform}>
      <ResourceForm isEdit={true} />
    </Edit>
  )
};

const Resource = {
  list: ResourceList,
  edit: ResourceEdit,
  create: ResourceCreate,
  // show: ResourceShow,
  icon: ChatIcon,
}

export default Resource;
